import config from '../js/config';

export class Plate {
    constructor(method, vars, reqType = 'POST', endPoint = config.apiURL) {
        this.method = method
        this.vars = vars
        this.reqType = reqType
        this.endPoint = endPoint
    }
}